import React from "react";

function ShrinkIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#fff"
        d="M14.648 10.477c-.656 0-1.125-.47-1.171-1.125V3.023c0-.609.328-1.171.89-1.406.188-.094.375-.094.61-.094.375 0 .75.141 1.03.422l2.204 2.203L22.055.352c.422-.47 1.125-.47 1.593 0a1.103 1.103 0 010 1.546l-3.843 3.844 2.203 2.203c.422.422.562 1.078.328 1.64-.234.563-.75.892-1.36.892h-6.328zm-5.25 3c.61 0 1.125.515 1.125 1.125v6.375c0 .609-.375 1.171-.937 1.406-.188.094-.375.094-.563.094-.421 0-.796-.141-1.078-.422l-2.203-2.203-3.844 3.796c-.187.235-.468.329-.75.329-.328 0-.609-.094-.796-.329-.47-.468-.47-1.171 0-1.593l3.796-3.844-2.203-2.203a1.516 1.516 0 01-.328-1.64c.235-.563.797-.891 1.406-.891h6.375zm.188-11.86c.562.235.937.797.844 1.36v6.421a1.06 1.06 0 01-1.078 1.079H3.023c-.609 0-1.171-.329-1.406-.891-.094-.188-.094-.375-.094-.61 0-.374.141-.75.422-1.03l2.203-2.204L.352 1.898a1.027 1.027 0 010-1.546 1.027 1.027 0 011.546 0l3.844 3.796 2.203-2.25c.282-.28.657-.421 1.078-.421.188 0 .375.046.563.14zm10.266 16.64l3.796 3.845a1.026 1.026 0 010 1.546c-.187.235-.468.329-.75.329-.328 0-.609-.094-.75-.375l-3.796-3.844-2.204 2.203a1.526 1.526 0 01-1.078.469c-.187 0-.375-.047-.562-.14-.563-.235-.938-.75-.938-1.36v-6.328c0-.61.47-1.079 1.078-1.079h6.375c.563 0 1.125.329 1.36.891a1.516 1.516 0 01-.328 1.64l-2.203 2.204z"
      ></path>
    </svg>
  );
}

export default React.memo(ShrinkIcon);
